<template>
    <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/>
</template>

<script>
    export default {
        name: 'arrow-right',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/ArrowRight.vue